<script setup>

import CloseButton from '../components/CloseButton.vue'
import NavButton from '../components/NavButton.vue'
import InfoPopup from '../components/InfoPopup.vue'
import FieldsTableRow from '../components/FieldsTableRow.vue'
import {computed, ref} from "vue";
import { store } from "@/store";

const yearOfBirth = computed({
  get() {
    return store.formData.user.yearOfBirth
  },
  set(val) {
    store.formData.user.yearOfBirth = val;
  }
})
const annuityRate = computed({
  get() {
    return store.formData.user.annuityRate
  },
  set(val) {
    store.formData.user.annuityRate = val;
  }
})
const sra = computed({
  get() {
    return store.formData.user.sra
  },
  set(val) {
    store.formData.user.sra = val;
  }
})
const sraBeforeSpa = computed({
  get() {
    return store.formData.user.sraBeforeSpa
  },
  set(val) {
    store.formData.user.sraBeforeSpa = val;
  }
})

const modalValid = computed(() => {
  return !!(sra.value && yearOfBirth.value)

})
const yearOfBirthErrors = computed(() => {
  return modalErrors.value.filter(error => error.field === 'yearOfBirth');
})
const sraErrors = computed(() => {
  return modalErrors.value.filter(error => error.field === 'selectedRetirementAge');
})
const generalErrors = computed(() => {
  return modalErrors.value.filter(error => !error.field);
})

const getAnnuity = async function () {
  const errors = [],
      {data: res} = await axios.get(`https://api.modeller.concertconsult.co.uk/api/v1/annuity?age=${sra.value}&yob=${yearOfBirth.value}`);

  if (res.data && res.data.rate) annuityRate.value = res.data.rate;
  else if (res.error && res.error.message) errors.push(res.error);
  else errors.push({
      field: false,
      message: 'We have not been able to find an annuity rate for the combination of selected retirement age and date of birth provided. Please check the information you entered, and if the issue persists contact your administrator.',
    });

  if (sra.value < sraRange.value.min || sra.value > sraRange.value.max) errors.push({
    field: 'selectedRetirementAge',
    message: `Your SRA must be between ${sraRange.value.min} and ${sraRange.value.max}`,
  });

  modalErrors.value = errors;

  if (errors.length === 0) {
    store.formState.page = 'retirementSavings';
    store.formState.modal = false;
  }
}

const modalErrors = ref([]);
const sraRange = ref({min: 55, max: 75});
</script>

<template>
  <div class="modal-2609 modal__sra">
    <div class="m__content">
      <CloseButton v-on:click="store.closeModal()">Close</CloseButton>

      <div class="fields-table">
        <table>
          <tbody>
          <FieldsTableRow v-bind:label="'Please enter the year you were born'" v-bind:errors="yearOfBirthErrors">
            <input v-model="yearOfBirth" type="number" min="0" step="1">
          </FieldsTableRow>
          <FieldsTableRow v-bind:label="'Please enter your Selected Retirement Age'" v-bind:errors="sraErrors">
            <input v-model="sra" type="number" :min="sraRange.min" :max="sraRange.max" step="1">
            <InfoPopup>
              <p>You can find your current Selected Retirement Age on ‘<a
                  href="https://dc.prudentialstaffps.co.uk/my-account" target="_blank">My account</a>’. Your Annual
                Benefit Statement uses this age to estimate your pension at retirement. In addtion, if your Personal
                Account is invested using one of the three Lifesyle Profiles, this age is used to manage the switching
                of your investments from higher to lower risk funds as you near retirement.</p>
            </InfoPopup>
          </FieldsTableRow>
          <FieldsTableRow v-bind:label="'Is this earlier than your State Pension Age?'">
            <input type="radio" id="yes" v-bind:value="true" v-model="sraBeforeSpa">
            <label for="yes"><span><span></span></span>Yes</label>
            <input type="radio" id="no" v-bind:value="false" v-model="sraBeforeSpa">
            <label for="no"><span><span></span></span>No</label>
            <InfoPopup>
              <p>You can check your State Pension Age at <a href="https://www.gov.uk/state-pension-age" target="_blank">www.gov.uk/state-pension-age</a>.
              </p>
              <p>If you indicate that your Selected Retirement Age is earlier than your State Pension Age, we will
                exclude your State Pension from the final results</p>
            </InfoPopup>
          </FieldsTableRow>
          </tbody>
        </table>
      </div>

      <p><br></p>
      <p>Click 'Next' to start adding your retirement savings.</p>
      <div class="nav-bar">
        <NavButton dir=">" class="no-pn" v-on:click="getAnnuity" v-bind:disabled="!modalValid">Next</NavButton>
      </div>
      <p
          class="m__error"
          v-for="(error, index) in generalErrors"
          :key="index"
      >
        {{ error.message }}
      </p>
    </div>
  </div>
</template>
